export const updateDatiOpzioniContrattuali = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};